export const environment = {
  production: false,
  apiURL: 'https://api.ksvs.dev.tremaze.de',
  keycloakURL: 'https://keycloak.dev.tremaze.de/auth',
  keycloakRedirectURL: "https://ksvs.dev.tremaze.de"
};
